import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './views/Home';
import NotFound from './views/NotFound';
import './App.css';
import './assets/styles/hino99.css';

const App = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/*" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;